import { inject, Injectable } from '@angular/core';
import { StorageProvider } from '../storage/storage';
import { Events } from '../events/events.provider';
import { CrView } from '../../models/v2/cr.model';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { LoggerFactory } from '../logger/logger-factory.service';

@Injectable({
  providedIn: 'root',
})
export class DraftCrService {
  private readonly storageListName = 'DraftOtCr_v2';
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this, true);
  private storageProvider: StorageProvider = inject(StorageProvider);
  private events: Events = inject(Events);

  async saveCrDraft(crView: CrView) {
    this.logger.info(`Call saveCrDraft pour l'ot ${crView.ot?.id_ot}`);
    await this.storageProvider.addDraft(crView, this.storageListName);
    this.events.publish('cr_list_update');
  }

  async getCrDraft(idOt: string): Promise<CrView> {
    this.logger.info(`Call getCrDraft pour l'ot ${idOt}`);
    return await this.storageProvider.get(this.storageListName + '_' + idOt);
  }

  async crDraftExists(idOt: string): Promise<boolean> {
    return !!(await this.getCrDraft(idOt));
  }

  async removeCrDraft(idOt: string): Promise<void> {
    this.logger.info(`Call removeCrDraft pour l'ot ${idOt}`);
    await this.storageProvider.removeDraft({ id: idOt }, this.storageListName);
    this.events.publish('cr_list_update');
  }

  async getAllCrDrafts(): Promise<CrView[]> {
    return await this.storageProvider.get(this.storageListName);
  }
}
